export function delay(t, v) {
    return new Promise(function(resolve) {
        setTimeout(resolve.bind(null, v), t)
    });
}

export function setCookie(cname, cvalue, seconds) {
    let d = new Date();
    d.setTime(seconds * 1000);
    let expires = 'expires='+ d.toUTCString();
    document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
};

export function getCookie(cname) {
    let name = cname + '=';
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for(let i = 0; i <ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return '';
};

export function deleteCookie(name) {
    if ( getCookie(name) ) {
        document.cookie = `${name}=${getCookie(name)}; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
    }
}

export function parseJwt(token) {
    let base64Url = token.split('.')[1];
    let base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    let jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));

    return JSON.parse(jsonPayload);
};

export function arrHasAnyEqualVal(arrBase, arrToCheck) {
    return Object.keys(arrBase).reduce((total, value)=> {
        total = !total ? Object.keys(arrToCheck).includes(value) : total;
        return total;
    }, false);
}

export function objToParams(obj) {
    if (obj && !Array.isArray(obj)) {
        return Object.keys(obj).reduce((total, key)=> {
            total = [...total, `${total.length ? '&' : '?'}${key}=${obj[key]}`];
            return total;
        }, []).join('');
    }
    return '';
}

export function hasQueryParams(route) {
    return !!Object.keys(route.query).length
}
